/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { ServiceTableEntry } from "~/models";
import { generateActionConfirmText } from "~/tools";

type Props = {
  service: ServiceTableEntry;
  removeCallback: (serviceId: string) => Promise<void>;
};

function PDServiceRemove({ service, removeCallback }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);

  const removeService = React.useCallback(async () => {
    try {
      await removeCallback(service.pagerdutyId);
    } finally {
      setIsOpen(false);
    }
  }, [removeCallback, service]);

  return (
    <>
      <Button
        icon="trash"
        size="sm"
        severity="low"
        onClick={() => setIsOpen(true)}
      >
        Remove
      </Button>

      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={removeService}
        actionLabel="Remove"
        contentLabel="Remove PagerDuty service"
      >
        {generateActionConfirmText(`service ${service.name}`)("remove")()}{" "}
        <br />
      </ModalConfirm>
    </>
  );
}

export { PDServiceRemove };
